import { dateFormatter } from '@dreryk/react-common';

import { LastUpdateInfo } from './SectionSummary.types';

export const formatLastUpdateLine = (prefix: string, lastUpdate: LastUpdateInfo): string =>
   `${prefix} ${lastUpdate.relative} (${dateFormatter(lastUpdate.absolute) ?? ''}, ${lastUpdate.author})`;
